import { Component } from 'react';
import PropTypes from 'prop-types';
import _ from '../../utils/ObjectUtils';
import Swal from "sweetalert2";
import { I18n } from 'react-redux-i18n';

export default class Alert extends Component {
    constructor(props) {
        super(props);
        this._show = false;
    }

    componentDidMount() {
        this.setupWithProps(this.props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.alertNextPropsAreDifferent(prevProps, this.props)) {
            this.setupWithProps(this.props);
        }
    }

    alertNextPropsAreDifferent = (prevProps, nextProps) => {
        const {
            show: currentShow,
            title: currentTitle,
            text: currentText,
            html: currentHtml,
            loading: currentLoading
        } = prevProps;

        const {
            show: nextShow,
            title: nextTitle,
            text: nextText,
            html: nextHtml,
            loading: nextLoading
        } = nextProps;

        return (
            currentShow !== nextShow ||
            currentTitle !== nextTitle ||
            currentText !== nextText ||
            currentHtml !== nextHtml ||
            currentLoading !== nextLoading
        );
    };

    setupWithProps(props) {
        const {
            show,
            title = "",
            text = "",
            html = "",
            type = "success", //[success, error, warning, info, question]
            confirmButtonText = I18n.t('forms.confirm'),
            cancelButtonText,
            allowOutsideClick = false,
            loading,
            loadingText = "Loading your request",
            onCancel = () => { },
            onConfirm = () => { }
        } = props;

        if (show || loading) {
            Swal.fire({
                type: loading? "" : type,
                title: loading? "" : title,
                html: loading? loadingText : html ? html : text,
                confirmButtonText,
                cancelButtonText,
                showCancelButton: !loading && !_.isNilOrEmpty(cancelButtonText),
                allowOutsideClick,
                onBeforeOpen: () => {
                    if(loading) Swal.showLoading()
                }
            }).then(
                result => {
                    if (_.has(result, "dismiss")) {
                        onCancel(result);
                    } else {
                        onConfirm(result);
                    }
                }, dismissReason => {
                    // [backdrop, cancel, close, esc, timer]
                    onCancel(dismissReason);
                }
            );
            this._show = true;
        } else {
            this.handleClose(onCancel);
        }
    }

    handleClose(onClose) {
        if (this._show) {
            Swal.close();
            if (onClose) onClose();
            this._show = false;
        }
    }

    render() {
        return null;
    }

}

Alert.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
    html: PropTypes.string,
    type: PropTypes.string,
    confirmButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
}
